import { Stack, Typography } from "@mui/material";
import { sysVersion } from "../config/settings";

const Footer = () => {
  const openWeb = () => {
    window.open("https://www.mybee.co.il", "_blank");
  }

  return (
    <Stack
      direction="row"
      padding={2}
      alignItems="center"
      justifyContent="space-between"
      bgcolor="primary.main"
      onClick={openWeb}
    >
      <Typography fontWeight="bold" fontSize={14} color="secondary">
        {`v-${sysVersion}`}
      </Typography>
      <Typography fontWeight="bold" fontSize={14} color="secondary">
        Powered by MyBee
      </Typography>
    </Stack>
  );
};
export default Footer;
